import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/tags`, {params})
    },
    create(params) {
        return Vue.axios.post(`/tags/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/tags/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/tags/remove/${id}`)
    },
    getListLandings(params){
        return Vue.axios.get(`/tag-landings`, {params})
    },
    getLanding(id){
        return Vue.axios.get(`/tag-landings/${id}`)
    },
    updateLanding(id, params){
        return Vue.axios.post(`/tag-landings/update/${id}`, params)
    }
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
